/* KIRA - homepage hero (Draft 2). Hamburger + autoplay safety. */
(function () {
  "use strict";

  var hero = document.getElementById("KiraHero");
  if (!hero) return;

  /* ---- the Unravel gate ----
     Click or keyboard-activate to enter. The body carries .body-loading
     (overflow:hidden) from the layout; drop it on entry so the page behaves
     normally afterwards. */
  var gate = document.getElementById("KiraGate");
  if (gate) {
    var openGate = function () {
      if (gate.getAttribute("data-open") === "0") return;
      gate.setAttribute("data-open", "0");
      document.body.classList.remove("body-loading");
      /* No programmatic focus: focusing the first link drew a visible ring on
         the mark for everyone. Hiding the gate returns focus to the document,
         and tabbing continues from the top of the page. */
      gate.setAttribute("hidden", "hidden");   // instant, as the original was
    };
    gate.addEventListener("click", openGate);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && gate.getAttribute("data-open") !== "0") openGate();
    });
  } else {
    document.body.classList.remove("body-loading");
  }

  /* ---- hamburger ---- */
  var burger = document.getElementById("KiraBurger");
  var panel = document.getElementById("KiraPanel");

  function setMenu(open) {
    if (!burger || !panel) return;
    burger.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      panel.setAttribute("data-open", "1");
    } else {
      panel.removeAttribute("data-open");
    }
    document.documentElement.style.overflow = open ? "hidden" : "";
  }

  if (burger && panel) {
    burger.addEventListener("click", function () {
      setMenu(burger.getAttribute("aria-expanded") !== "true");
    });
    panel.addEventListener("click", function (e) {
      if (e.target === panel) setMenu(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && burger.getAttribute("aria-expanded") === "true") {
        setMenu(false);
        burger.focus();
      }
    });
  }

  /* ---- close the panel if the viewport grows past the breakpoint ----
     The burger and corner nav swap at 760px, but the panel is fixed inset:0 and
     has no width rule - left open, it covers the whole desktop layout. */
  var mq = window.matchMedia("(min-width: 761px)");
  var onWide = function (e) {
    if (e.matches && burger && burger.getAttribute("aria-expanded") === "true") setMenu(false);
  };
  if (mq.addEventListener) { mq.addEventListener("change", onWide); }
  else if (mq.addListener) { mq.addListener(onWide); }

  /* ---- Story dropdown: keyboard parity with the CSS hover ---- */
  var storyBtn = hero.querySelector(".kira-hero__story-btn");
  if (storyBtn) {
    storyBtn.addEventListener("click", function () {
      var open = storyBtn.getAttribute("aria-expanded") === "true";
      storyBtn.setAttribute("aria-expanded", open ? "false" : "true");
    });
  }

  /* ---- keep the loop alive if the browser blocks muted autoplay ---- */
  var video = hero.querySelector(".kira-hero__film video");
  if (video) {
    var kick = function () {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    };
    kick();
    document.addEventListener("click", kick, { once: true });
    document.addEventListener("touchstart", kick, { once: true, passive: true });
  }
})();
